module.exports = __webpack_public_path__ + "static/media/feature-3.18a8c265.png";